import { getStore } from '../store/store';

/**
 * Gets the ID of the active drawer pane for the specified window.
 * Finds the pane with `isShown === true` for the given tabId.
 *
 * @param tabId - The ID of the tab for which to get the active drawer pane.
 * @returns The pane ID, or undefined if no pane is shown.
 */
export default function getActiveDrawerPane(tabId: string): string | undefined {
    const tabMap = getStore().paneStateMap.get(tabId);
    if (!tabMap) {
        return undefined;
    }

    for (const [paneId, state] of tabMap) {
        if (state.isShown) {
            return paneId;
        }
    }
    return undefined;
}
